import React, { useState, useEffect } from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { TbAlertTriangle, TbAnalyze } from "react-icons/tb";
import { BiMinusCircle } from "react-icons/bi";
import { isIgnoreTestForDisplay, isInconclusive, isOther, isNegativeResult, isPositiveResult, TEST_CATEGORIES } from "../../util/resultUtils";

const ResultDetails = props => {
  const [results, setResults] = useState(props.testResults);
  const [positiveResults, setPositiveResults] = useState([]);
  const [negativeResults, setNegativeResults] = useState([]);
  const [inconclusiveResults, setInconclusiveResults] = useState([]);
  const [otherResults, setOtherResults] = useState([]);

  useEffect(() => {
    const filteredResults = results.filter(result => {
      return !isIgnoreTestForDisplay(result);
    });
    console.log(filteredResults);

    const positiveTests = filteredResults.filter(result => {
      return isPositiveResult(result);
    });
    setPositiveResults(positiveTests);

    const negativeTests = filteredResults.filter(result => {
      return isNegativeResult(result);
    });
    setNegativeResults(negativeTests);

    const inconclusiveTests = filteredResults.filter(result => {
      return isInconclusive(result);
    });
    setInconclusiveResults(inconclusiveTests);

    const otherResults = filteredResults.filter(result => {
      return isOther(result);
    });
    setOtherResults(otherResults);
  }, []);

  if (props.displayOnlyTestResults === true) {
    return (
      <>
        <Row className="ResultDetails">
          <Col md={3} className="resultCol">
            <Badge bg="danger" id="positive-test">
              <TbAlertTriangle /> {TEST_CATEGORIES.POSITIVE}
            </Badge>
            <div id="posRes">
              <div class="display_results pos_display">
                {positiveResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>
          <Col md={3} className="resultCol">
            <Badge bg="success" id="negative-test">
              <BiMinusCircle /> {TEST_CATEGORIES.NEGATIVE}
            </Badge>
            <div id="negRes">
              <div class="display_results neg_display">
                {negativeResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>
          <Col md={3} className="resultCol">
            <Badge bg="warning" id="positive-test">
              <TbAlertTriangle /> {TEST_CATEGORIES.INCONCLUSIVE}
            </Badge>
            <div id="posRes">
              <div class="display_results non_rect_display">
                {inconclusiveResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>
          <Col md={3} className="resultCol">
            <Badge bg="primary" id="positive-test">
              <TbAnalyze /> {TEST_CATEGORIES.OTHER}
            </Badge>
            <div id="posRes">
              <div class="display_results other">
                {otherResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                      {individualResult.units}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </>
    );
  }

  return (
    <>
      <Row className="ResultDetails">
          <Col md={3} className="resultCol">
            <Badge bg="danger" id="positive-test">
              <TbAlertTriangle /> {TEST_CATEGORIES.POSITIVE}
            </Badge>
            <div id="posRes">
              <div class="display_results pos_display">
                {positiveResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>
          <Col md={3} className="resultCol">
            <Badge bg="success" id="negative-test">
              <BiMinusCircle /> {TEST_CATEGORIES.NEGATIVE}
            </Badge>
            <div id="negRes">
              <div class="display_results neg_display">
                {negativeResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>
        

          <Col md={3} className="resultCol">
            <Badge bg="warning" id="positive-test">
              <TbAlertTriangle /> {TEST_CATEGORIES.INCONCLUSIVE}
            </Badge>
            <div id="posRes">
              <div class="display_results non_rect_display">
                {inconclusiveResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>


          <Col md={3} className="resultCol">
            <Badge bg="primary" id="positive-test">
              <TbAnalyze /> {TEST_CATEGORIES.OTHER}
            </Badge>
            <div id="posRes">
              <div class="display_results other">
                {otherResults?.map((individualResult, index) => {
                  return (
                    <p key={index}>
                      {individualResult.testName} - {individualResult.result}
                      {individualResult.units}
                    </p>
                  );
                })}
              </div>
            </div>
          </Col>

      </Row>
      <Row className="modal-footer">
        {/* <button id="msg_reply" onClick={props.sendResult} class="btn btn-primary">Send Results <i class="fa fa-paper-plane" aria-hidden="true"></i></button> */}
        {props.hasAttachments
          ? props.attachments?.map((url, index) => (
              <a key={index} target="_blank" href={url}>
                {" "}
                <button id="msg_reply" className="btn btn-primary">
                  View Result PDF
                </button>{" "}
              </a>
            ))
          : null}
      </Row>
    </>
  );
};

export default ResultDetails;
